import styled, { css, keyframes } from 'styled-components'
import { rem } from 'utils/common'
import { device, merchantThemes } from '../Variable'
import { slideInDown } from 'react-animations'

const slideInDownAnimation = keyframes`${slideInDown}`

export const HeaderStyle = styled.div`
	position: fixed;
	left: 0;
	right: 0;
	top: ${rem(-1)};
	height: ${rem(80)};
	z-index: 900;
	background-color: ${({ theme }) => theme.color.secondary};
	display: flex;
	flex-flow: row wrap;
	align-items: center;
	justify-content: space-between;
	border-bottom: ${rem(1)} solid ${({ theme }) => theme.color.grayOne};
	padding: ${rem(0, 10)};

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			border-bottom: ${rem(1)} solid ${({ theme }) => theme.color.primary};
		`}

	.logoReturnado {
		max-height: ${rem(38)};
		transform: translateX(${rem(12)});
	}

	@media (${device.tablet}) {
		padding: 0;
		.logoReturnado {
			transform: translateX(0);
		}
	}
	@media (${device.mobileL}) {
		height: ${rem(64)};
		padding: ${rem(0, 5)};
		& > div {
			padding: ${rem(0, 5)};
			flex: 0 0 35%;
			max-width: 35%;

			&:nth-child(2) {
				flex: 0 0 25%;
				max-width: 25%;
				padding: ${rem(0, 10)};
			}
		}

		.logoReturnado {
			max-height: ${rem(32)};
		}
	}

	${(p) =>
		p.headerClass === 'visible' &&
		css`
			display: flex;
			animation: 0.5s ${slideInDownAnimation};
		`}
	${(p) =>
		p.headerClass === 'invisible' &&
		css`
			display: none;
		`}
`

export const HeaderLogout = styled.div`
	${(p) =>
		p.modeApp === 'modal' &&
		css`
			display: block;
			width: ${rem(50)};
			height: ${rem(50)};
			border-radius: 50%;
			background-color: ${({ theme }) => theme.color.blackOne};
			box-shadow: ${rem(2)} ${rem(2)} ${rem(3)} ${rem(2)}
					rgba(0, 0, 0, 0.3),
				0 ${rem(3)} ${rem(7)} ${rem(4)} rgba(0, 0, 0, 0.15);
			position: fixed;
			top: ${rem(-25)};
			right: ${rem(-25)};
			z-index: 901;
			cursor: pointer;
			& > svg {
				fill: ${({ theme }) => theme.color.secondary};
				width: ${rem(10)};
				height: ${rem(10)};
				position: absolute;
				top: ${rem(30)};
				right: ${rem(30)};
			}
		`}
	${(p) =>
		p.modeApp === 'default' &&
		css`
			& > svg {
				display: none;
			}
		`}
`
